// extracted by mini-css-extract-plugin
export default {"appBtn":"style_appBtn__EoMzj"};